import styled from 'styled-components';

export const PreloaderContainer = styled.div`
	height: 100dvh;
	display: flex;
	justify-content: center;
	align-items: center;
`;
